export default __webpack_public_path__ + "static/media/right-front-ring.66650e6c.png";